export default __webpack_public_path__ + "static/media/indepth_ass.520bebc9.png";